import DropdownMenu from "../helpers/menu/dropdown";

export function initDropdownMenu() {
    const elem = document.querySelector('.js-dropdown');

    if (elem !== null) {
        new DropdownMenu(elem, {
            selectors: {
                dropdown: '.dropdown__container',
                root: 'html',
                closing: '.js-dropdown-close'
            },
            classes: {
                default: 'is-active',
                root: 'dropdown-active',
            }
        });
    }
}
